import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import commonMessages from './commonMessages';



const POSITION_STYLES = {
    'top-left': { top: 8, left: 8 },
    bottom: {
        bottom: -6,
        right: -6
    }
};

const GifTag = ({ visible, position, intl }) => {
    if (!visible) return null;

    return (
        <span
            className="gif-tag"
            style={{
                position: 'absolute',
                zIndex: 2,
                pointerEvents: 'none',
                ...POSITION_STYLES[position]
            }}
        >
            <span aria-hidden="true">GIF</span>
            <span className="visually-hidden-span">
                {intl.formatMessage(commonMessages.animatedDesignPausedLabel)}
            </span>
        </span>
    );
};

GifTag.propTypes = {
    visible: PropTypes.bool,
    position: PropTypes.oneOf(['top-left', 'bottom']),
    intl: intlShape.isRequired
};

GifTag.defaultProps = {
    visible: false,
    position: 'top-left'
};

export default injectIntl(GifTag);
